import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import "../../../assets/css/downloadButton.css";
import { useDispatch, useSelector } from "react-redux";
import "../../../assets/css/loadingwrapper.css";
import {
  stripeCustomerAllPaidInvoicesData,
  stripeCustomerData,
} from "../../../Redux/Stripe/action";

const Invoices = () => {
  const dispatch = useDispatch();
  const paymentData = useSelector((state) => state.authReducer.paymentData);
  const [customerData, setCustomerData] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const customerByIdSuccess = useSelector(
    (state) => state.stripeReducer.customerByIdSuccess,
  );
  const customerAllPaidInvoicesByIdSuccess = useSelector(
    (state) => state.stripeReducer.customerAllPaidInvoicesByIdSuccess,
  );

  useEffect(() => {
    const fetchData = async () => {
      if (paymentData) {
        try {
          await stripeCustomerData(dispatch, paymentData?.customerID);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData();
  }, [paymentData]);

  useEffect(() => {
    const fetchData = async () => {
      if (customerData) {
        try {
          await stripeCustomerAllPaidInvoicesData(
            dispatch,
            100,
            customerData?.id,
            "paid",
          );
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData();
  }, [customerData]);

  useEffect(() => {
    if (customerByIdSuccess) {
      setCustomerData(customerByIdSuccess);
    }
  }, [customerByIdSuccess]);
  useEffect(() => {
    if (customerAllPaidInvoicesByIdSuccess) {
      setInvoices(customerAllPaidInvoicesByIdSuccess?.data);
    }
  }, [customerAllPaidInvoicesByIdSuccess]);

  function formatCurrency(amount) {
    const formattedAmount = (Math.abs(amount) / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });

    return {
      formatted: amount > 0 ? `-${formattedAmount}` : `+${formattedAmount}`,
      color: amount > 0 ? "red" : "green",
    };
  }

  function capitalizeFirstLetter(str) {
    return str.replace(/\b\w/g, (match) => match.toUpperCase());
  }

  function CustomDownloadButton({ downloadLink }) {
    const handleDownload = () => {
      window.open(downloadLink, "_blank");
    };

    return (
      <button className="Btn" type="button" onClick={handleDownload}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 384 512"
          className="svgIcon"
        >
          <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path>
        </svg>
        <span className="icon2"></span>
      </button>
    );
  }

  return (
    <>
      {invoices.length > 0 ? (
        <>
          <Table>
            <thead>
              <tr className={"custom-style-settings-menu-bold"}>
                <th>Date</th>
                <th>Invoice #</th>
                <th>Amount</th>
                <th>Details</th>
                <th className={"d-flex justify-content-center"}>Action</th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((invoice, index) => (
                <tr key={index}>
                  <td>
                    {new Date(invoice.created * 1000).toLocaleDateString()}
                  </td>
                  <td>{invoice.number}</td>
                  <td
                    style={{
                      color: formatCurrency(invoice.total).color,
                      fontWeight: "bolder",
                    }}
                  >
                    {formatCurrency(invoice.total).formatted}
                  </td>
                  <td>
                    {capitalizeFirstLetter(
                      invoice.billing_reason.replace(/_/g, " "),
                    )}
                  </td>
                  <td className={"d-flex justify-content-center"}>
                    <CustomDownloadButton downloadLink={invoice.invoice_pdf} />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        <>
          <div className="loader-invoices">
            <div className="wrapper">
              <div className="circle"></div>
              <div className="line-1"></div>
              <div className="line-2"></div>
              <div className="line-3"></div>
              <div className="line-4"></div>
              <div className="line-5"></div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Invoices;
